// extracted by mini-css-extract-plugin
module.exports = {"option":"DeliveryOptions_option__XDD5o","headline":"DeliveryOptions_headline__ohqPA","description":"DeliveryOptions_description__xVWmh","price":"DeliveryOptions_price__u69q0"};